var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-xs uppercase md:font-medium tracking-wide md:block whitespace-no-wrap mr-2 md:mr-0 md:ml-4 md:mb-1"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }